import { Box, Typography } from '@mui/material';
import { Theme } from '@mui/material/styles/createTheme';
import { SxProps } from '@mui/system/styleFunctionSx';
import ArrowRight from '@nuuday/yousee-dna/generated/icons/general/ArrowRight';
import React from 'react';
import { Link } from 'react-router-dom';
import { strings } from 'shared/utils/formatting/strings';
import { getHtmlId } from 'utils/misc';

type Props = {
  title: string;
  titleType?: 'h2' | 'h3';
  titleParams?: { [key: string]: string };
  cardIcon?: React.ReactNode;
  iconSize?: number;
  description?: string | React.ReactNode;
  path?: string;
  href?: string;
  sx?: SxProps<Theme>;
};

export const CardHeader = ({
  title,
  titleType = 'h2',
  titleParams,
  cardIcon,
  iconSize,
  description,
  path,
  href,
  sx,
}: Props) => {
  const cardIconSx: SxProps<Theme> = {
    'pr': { xs: 5, sm: 3 },
    'display': 'flex',
    'justifyContent': 'center',
    'alignItems': 'flex-start',
    '& > svg': { width: iconSize ? iconSize : { xs: 48, sm: 64 } },
  };

  const content = (
    <Box sx={{ display: 'flex', p: { xs: 4, sm: 5 }, ...sx }}>
      {cardIcon && <Box sx={cardIconSx}>{cardIcon}</Box>}
      <Box sx={{ width: 1, wordBreak: 'break-word' }}>
        <Typography
          variant={titleType}
          id={getHtmlId(title)}
          sx={titleType === 'h2' ? { fontSize: { xs: '20px', md: '24px' } } : {}}>
          {titleParams ? strings.buildText(title, titleParams) : title}
        </Typography>
        {description && (
          <Typography variant='regular16' sx={{ mt: 1, mb: 0, ['& > p']: { marginBlock: 0 } }}>
            {description}
          </Typography>
        )}
      </Box>
    </Box>
  );

  const linkSx: SxProps<Theme> = {
    display: 'flex',
    justifyContent: 'space-between',
    textDecoration: 'inherit',
    color: 'inherit',
  };

  const ArrowIcon = () => (
    <Box sx={{ p: { xs: 4, sm: 5 } }}>
      <ArrowRight width={36} />
    </Box>
  );

  return path ? (
    <Box component={Link} sx={linkSx} to={path}>
      {content}
      <ArrowIcon />
    </Box>
  ) : href ? (
    <Box component='a' sx={linkSx} href={href} target='_blank'>
      {content}
      <ArrowIcon />
    </Box>
  ) : (
    content
  );
};
